module.exports = __webpack_public_path__ + "img/jazz_xxl_light_grey_ba_list.262db6c2.jpg";